<style>
</style>
<template>
  <div>
    <div class="mui-content">
      <form id="login-form" class="mui-input-group">
        <div class="mui-input-row">
          <label>用户名</label>
          <input
            id="account"
            type="text"
            class="mui-input-clear mui-input"
            v-model="username"
            placeholder="请输入用户名"
          />
        </div>
        <div v-if="from !== '1'" class="mui-input-row">
          <label>手机号码</label>
          <button
            @click.prevent=""
            style="
              width: 25%;
              float: right;
              padding: 6px;
              height: 38px;
              margin: 1px 0;
            "
            @click="sendSMS"
          >
            {{ sendSMSCountDown }}
          </button>
          <input
            id="phone"
            type="text"
            v-model="phone"
            placeholder="请输入手机号码"
            style="width: 40%"
          />
        </div>

        <div v-if="from !== '1'" class="mui-input-row">
          <label>验证码</label>
          <input
            id="yzm"
            type="text"
            v-model="yzm"
            placeholder="请输入验证码"
            class="mui-input-clear mui-input"
          />
        </div>

        <div class="mui-input-row">
          <label>密码</label>
          <input
            id="password"
            type="password"
            class="mui-input-clear mui-input"
            v-model="password"
            placeholder="请输入密码"
          />
        </div>
        <div class="mui-input-row">
          <label>确认密码</label>
          <input
            id="confirmPassword"
            type="password"
            class="mui-input-clear mui-input"
            v-model="confirmPassword"
            placeholder="请输入密码"
          />
        </div>

        <div class="mui-input-row">
          <label>所属城市</label>
          <select name="" id="" v-model="admin_id" @change="changefzr($event)">
            <!-- <option value="-1"  selected>苏州市总负责人</option> -->
            <option value="-1" selected>请选择所属城市</option>
            <template v-for="item in fzr">
              <option :value="item.id" :key="item.id">{{ item.nickname }}</option>
            </template>
          </select>
        </div>
      </form>
      <div class="mui-content-padded">
        <button
          type="button"
          class="mui-btn mui-btn-block mui-btn-primary"
          @click="register"
        >
          注册
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "mint-ui";

export default {
  name: "register",
  data() {
    return {
      username: "",
      password: "",
      confirmPassword: "",
      phone: "",
      title: "用户注册",
      sendSMSCountDown: "获取验证码",
      timeOut: "",
      yzm: "",
      fzr: {},
      admin_id: "",
      from: "", //来自
    };
  },
  methods: {
    register() {
      // if (this.username === '' || this. === '') {
      //   if( ( this.phone === '' || this.yzm === '' )&& this.from!=='1'  ){
      //     Toast('账号/密码/手机号码/验证码不能为空')
      //     return false
      //   }else{
      //
      //   }
      // }

      if (this.username === "") {
        Toast("账号为空");
        return false;
      }

      if (this.password === "") {
        Toast("密码为空");
        return false;
      }

      if (this.phone === "" && this.from !== "1") {
        Toast("手机号为空");
        return false;
      }
      if (this.yzm === "" && this.from !== "1") {
        Toast("验证码为空");
        return false;
      }
      if (this.password !== this.confirmPassword) {
        Toast("两次密码不一致");
        return false;
      }
      if (!this.isPhoneNo(this.phone)) {
        Toast("手机号错误");
        return false;
      }
      if (this.admin_id == -1) {
        Toast("请选择所属城市");
        return false;
      }
      if (this.admin_id === "") {
        this.admin_id = this.fzr[0].id;
      }
      this.$http
        .post(
          "api/gather/register",
          {
            name: this.username,
            pass: this.password,
            phone: this.phone,
            // 'openid': window.localStorage.getItem('userOpenid'),
            code: this.yzm,
            admin_id: this.admin_id,
            from: this.from,
          },
          { emulateJSON: true }
        )
        .then(function (data) {
          Toast(data.body.msg);
          if (data.body.code === 1) {
            // window.localStorage.setItem('uid', data.body.data.uid)
            setTimeout(() => {
              this.$router.push({ path: "/user/login" });
            }, 2000);
          }
        });
    },
    isPhoneNo(phone) {
      var pattern = /^1[0-9]{10}$/;
      return pattern.test(phone);
    },
    sendSMS() {
      if (!this.isPhoneNo(this.phone)) {
        Toast("手机号错误");
        return false;
      }
      if (
        window.localStorage.getItem("sendSMSCountDown") === "" ||
        window.localStorage.getItem("sendSMSCountDown") == 0
      ) {
        window.localStorage.setItem("sendSMSCountDown", 0);
      } else {
        Toast("操作太频繁，请等待60s");
        return;
      }

      if (
        this.sendSMSCountDown === "获取验证码" &&
        window.localStorage.getItem("sendSMSCountDown") == 0
      ) {
        var that = this;
        this.$http
          .post(
            "api/gather/sendSMS",
            {
              mobile: this.phone,
              openid: window.localStorage.getItem("userOpenid"),
            },
            { emulateJSON: true }
          )
          .then(function (data) {
            Toast(data.body.msg);
            if (data.body.code === 1) {
              var countinterval = setInterval(function () {
                var s =
                  that.sendSMSCountDown === "获取验证码"
                    ? 60
                    : that.sendSMSCountDown;
                if (s <= 0) {
                  window.localStorage.setItem("sendSMSCountDown", 0);
                  that.sendSMSCountDown = "获取验证码";
                  clearInterval(countinterval);
                  return;
                }
                window.localStorage.setItem("sendSMSCountDown", s - 1);
                that.sendSMSCountDown = s - 1;
              }, 1000);
            }
          });
      } else {
        alert("error");
      }
    },
    webViewTimer() {
      this.timeOut = setTimeout(() => {}, 1000);
    },
    changefzr(e) {
      console.log(e.target.value);
      this.admin_id = e.target.value;
    },
  },
  created() {
    var from = this.$route.query["from"];
    if (from === "1") {
      //来自smslogin未注册
      this.from = from;
      this.phone = this.$route.query["phone"];
    }
    this.$emit("getTitle", this.title);
    window.localStorage.setItem("sendSMSCountDown", 0);
    this.$http
      .get("api/gather/getAdminList", {}, { emulateJSON: true })
      .then(function (data) {
        this.fzr = data.body.data;
        this.admin_id = -1;
      });
  },
};
</script>

<style scoped>
.mui-content {
  margin-top: 5%;
}
</style>



// WEBPACK FOOTER //
// src/components/user/register.vue